export default "__VITE_ASSET__BY1gC8SF__"